import React from 'react'
import { makeStyles, Box, Grid, Typography, Container } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  pageSection: {
    paddingTop: '3rem',
    background: theme.palette.background.dark1,
    paddingBottom: '6rem',
    
    '& p': {
      fontStyle: 'regular',
    },
  },
  loremtext: {
    '& h1': {
      fontSize: '50px',
      fontWeight: '600',
      color: theme.palette.text.black,
      marginBottom: '20px',
      textAlign: "left",
      [theme.breakpoints.down('sm')]:{
        fontSize: '30px',
      },
    },
    '& p': {
      width: '100%',
      fontSize: '15px',

      textAlign: 'left',
      color: '#797979',
    },
    '@media(min-width:200px) and (max-width:300px)': {
      '& h1': {
        fontSize: '20px',
      },
    },
  },
}))

function Become() {
  const classes = useStyles()
  return (
    <>
      <Box className={classes.pageSection}>
        <Container maxWidth="lg">
          <Grid container spacing={3} align="center">
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box className={classes.loremtext}>
                <Typography variant="h1">
                  Become a PRO
                  <br /> in Crypto Investment
                </Typography>
                <Box mt={2}>
                  <Typography variant="body1">
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                    Error quas, maxime voluptatem quaerat suscipit sit
                    voluptatum temporibus. Eveniet labore ad aliquid dolore est
                    ipsum quis voluptatem voluptas culpa porro? Ex, voluptatum
                    temporibus. Eveniet labore ad aliquid dolore est ipsum quis
                    voluptatem voluptas culpa porro?
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={2}></Grid>
            <Grid item xs={12} sm={12} md={5} lg={4}>
              <Box className={classes.imgStyle}>
                <video
                  controls
                  loop="true"
                  autoplay="true"
                  width="100%"
                >
                  <source
                    src="./video/video.mp4"
                    type="video/mp4"
                    style={{
                      border: '1px solid #F83838',
                    }}
                  />
                </video>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  )
}

export default Become
